export default __webpack_public_path__ + "static/kyc_instruction-4c17c093aa5606514667ecef1cd7a7fe.png";